import { Table, PaginationContainer, QueryParamsManager } from "./components";

export function ProxyTab() {
    return (
        <>
            <Table />
            <PaginationContainer />
            <QueryParamsManager />
        </>
    )
}